import { useRef, useState } from 'react';
import classNames from 'classnames';
import useRawMarkup from 'hooks/useRawMarkup';

interface Props {
  title: string;
  content: string;
}

const CollapseCard = (props: Props) => {
  const { title, content } = props;

  const contentRef = useRef<HTMLDivElement | null>(null);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const classes = classNames('collapse-card', {
    'collapse-card--open': isOpen,
  });

  const contentClasses = classNames('collapse-card__content', {
    'collapse-card__content--open': isOpen,
  });

  const toggleArrowClasses = classNames(
    'collapse-card__btn-toggle-arrow-icon',
    {
      'collapse-card__btn-toggle-arrow-icon--open': isOpen,
    },
  );

  const currentHeight = isOpen ? contentRef.current?.scrollHeight : 0;

  const onToggle = () => {
    setIsOpen(prev => !prev);
  };

  return (
    <div className={classes}>
      <button className="collapse-card__btn-header" onClick={onToggle}>
        <span className="collapse-card__btn-header-title">{title}</span>
        <span className="collapse-card__btn-toggle-arrow">
          <span className={toggleArrowClasses}></span>
        </span>
      </button>
      <div
        ref={contentRef}
        className={contentClasses}
        style={{ height: currentHeight }}
        dangerouslySetInnerHTML={useRawMarkup(content)}
      />
    </div>
  );
};

export default CollapseCard;
